export const honorfic = [
    { name: 'DR.', code: 'Dr.' },
    { name: 'MR.', code: 'MR.' },
    { name: 'MRS.', code: 'MRS.' },
    { name: 'MS.', code: 'MS.' },
];